import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './AuthContext';
import Login from './Login';
import Register from './Register';
import ForgotPassword from './ForgotPassword';
import DocumentEditor from './DocumentEditor';
import Layout from './Layout';
import Profile from './Profile';
import Settings from './Settings';
import ChangePassword from './ChangePassword';
import Schedule from './Schedule';
import TableSign from './TableSign';
import UnitSort from './UnitSort';
import Messages from './Messages';
import './App.css';

// 受保护的路由组件
const ProtectedRoute = ({ children }) => {
  const { user, loading, isGuest, guestLogin } = useAuth();
  
  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>加载中...</p>
      </div>
    );
  }
  
  // 如果没有登录且不是游客，自动设置为游客模式
  if (!user && !isGuest) {
    guestLogin();
  }
  
  return <Layout>{children}</Layout>;
};

// 公共路由组件（登录、注册、忘记密码页面）
const PublicRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>加载中...</p>
      </div>
    );
  }
  
  // 已登录用户访问登录页时跳转到首页
  if (user) {
    return <Navigate to="/" replace />;
  }
  
  return children;
};

// 主应用组件
const AppContent = () => {
  return (
    <Routes>
      {/* 公共路由 */}
      <Route 
        path="/login" 
        element={
          <PublicRoute>
            <Login />
          </PublicRoute>
        } 
      />
      <Route 
        path="/register" 
        element={
          <PublicRoute>
            <Register />
          </PublicRoute>
        } 
      />
      <Route 
        path="/forgot-password" 
        element={
          <PublicRoute>
            <ForgotPassword />
          </PublicRoute>
        } 
      />
      
      {/* 受保护的路由 */}
      <Route 
        path="/" 
        element={
          <ProtectedRoute>
            <DocumentEditor />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/profile" 
        element={
          <ProtectedRoute>
            <Profile />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/settings" 
        element={
          <ProtectedRoute>
            <Settings />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/change-password" 
        element={
          <ProtectedRoute>
            <ChangePassword />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/schedule" 
        element={
          <ProtectedRoute>
            <Schedule />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/table-sign" 
        element={
          <ProtectedRoute>
            <TableSign />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/unit-sort" 
        element={
          <ProtectedRoute>
            <UnitSort />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/messages" 
        element={
          <ProtectedRoute>
            <Messages />
          </ProtectedRoute>
        } 
      />
      
      {/* 默认重定向 */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Router>
  );
}

export default App;
